import { useOutletContext } from 'react-router';
import { IconType } from 'react-icons';
import { FaRegUser } from 'react-icons/fa';
import { RiBarricadeLine } from 'react-icons/ri';
import { RiBaseStationFill } from 'react-icons/ri';
import { TbDeviceDesktopQuestion } from 'react-icons/tb';
import { LuClipboardSignature } from 'react-icons/lu';
import { CgDanger } from 'react-icons/cg';
import { CgGlobe } from 'react-icons/cg';
import { CgCodeClimate } from 'react-icons/cg';
import applicationSettings from '../../infrastructure/config';
import { UserInfo } from '../../infrastructure/userInfo';
import { Example } from './Example';
import styles from './Example.module.css';

const defaultExamples: Question[] = [
  {
    question: 'What kinds of questions can I ask you?',
    icon: TbDeviceDesktopQuestion,
    iconColor: '#B56700',
    iconSize: 24,
    caseSearch: false,
    caseRegistration: false,
  },
  {
    question: 'Can you create a case for me?',
    icon: LuClipboardSignature,
    iconColor: '#009FDA',
    iconSize: 20,
    caseSearch: false,
    caseRegistration: true,
  },
  {
    question: 'Are there any cases related to falling objects?',
    icon: CgDanger,
    iconColor: '#ec9286',
    iconSize: 22,
    caseSearch: true,
    caseRegistration: false,
  },
  {
    question: 'How to change my password in Synergi Life?',
    icon: RiBarricadeLine,
    iconColor: '#009FDA',
    iconSize: 20,
    caseSearch: false,
    caseRegistration: false,
  },
  {
    question: 'How can I create a user?',
    icon: FaRegUser,
    iconColor: '#A1AAE6',
    iconSize: 22,
    caseSearch: false,
    caseRegistration: false,
  },
];

interface Props {
  onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
  const { userInfo } = useOutletContext<{ userInfo?: UserInfo }>();

  const icons: { iconType: IconType; color: string; size: number }[] = [
    { iconType: TbDeviceDesktopQuestion, color: '#B56700', size: 24 },
    { iconType: LuClipboardSignature, color: '#009FDA', size: 20 },
    { iconType: CgDanger, color: '#ec9286', size: 22 },
    { iconType: CgGlobe, color: '#A1AAE6', size: 22 },
    { iconType: CgCodeClimate, color: '#009FDA', size: 22 },
    { iconType: RiBarricadeLine, color: '#caad0a', size: 20 },
    { iconType: RiBaseStationFill, color: '#B56700', size: 20 },
    { iconType: FaRegUser, color: '#A1AAE6', size: 22 },
  ];
  const tenantQuestions =
    applicationSettings.sampleQuestions.map((q) => {
      const icon =
        icons[q.question.split('').reduce((a, b) => a + b.charCodeAt(0), 0) % icons.length];
      return {
        ...q,
        icon: icon.iconType,
        iconColor: icon.color,
        iconSize: icon.size,
      } as Question;
    }) || [];
  const examples = [...tenantQuestions, ...defaultExamples]
    .filter(
      (example) =>
        (!example.caseRegistration ||
          (example.caseRegistration === applicationSettings.caseRegisterEnabled &&
            userInfo?.aiCaseAccess)) &&
        (!example.caseSearch || example.caseSearch === applicationSettings.caseSearchEnabled)
    )
    .slice(0, 3);
  return (
    <ul className={styles.examplesNavList}>
      {examples.map((example, i) => (
        <li key={i}>
          <Example
            icon={<example.icon size={example.iconSize} color={example.iconColor} />}
            text={example.question}
            value={example.question}
            onClick={onExampleClicked}
          />
        </li>
      ))}
    </ul>
  );
};

interface Question {
  question: string;
  icon: IconType;
  iconColor: string;
  iconSize: number;
  caseSearch: boolean;
  caseRegistration: boolean;
}
